import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section className="pt-32 pb-24 px-6 relative overflow-hidden min-h-screen flex items-center">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/fcfd1be3be4a9f62068ab95502bc6268.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/75"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10 w-full">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-block px-4 py-2 bg-teal-500/10 border border-teal-400/30 rounded-full mb-6"
          >
            <span className="text-sm font-semibold text-teal-300">Die komplette Business Suite für SuperOne-Partner</span>
          </motion.div>

          {/* Main Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-[1.1]"
          >
            Deine Online Business Suite für{' '}
            <span className="text-[#0066FF]">SuperOne</span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl md:text-2xl text-gray-300 mb-10 leading-relaxed"
          >
            Alles, was du brauchst, um als SuperOne-Partner erfolgreich zu sein: Leadgenerierung, CRM, Automatisierung und KI-gestützte Tools – alles in einer Plattform.
          </motion.p>
        </div>
      </div>
    </section>
  );
}
